import { ACTIONS_TYPES } from "../utils/constants";




export function getJobAuditsRequest(payload) {
  return {
    type: ACTIONS_TYPES.GET_JOB_AUDITS_REQUEST,
    payload,
  }
}

export function getJobAuditsSuccess(response) {
  return {
    type: ACTIONS_TYPES.GET_JOB_AUDITS_SUCCESS,
    payload: response,
  }
}

export function getJobAuditsFailed(error) {
  return {
    type: ACTIONS_TYPES.GET_JOB_AUDITS_FAILED,
    payload: error,
  }
}
